import React from 'react';

type Props = {
    children: React.ReactNode;
};

// No logic, just renders <Main.Crumb>s so they register in the BreadcrumbContext
export const BreadcrumbsMain = ({ children }: Props) => <>{children}</>;
